module.exports = __webpack_public_path__ + "img/header-diamondJewelrySignet.14e482d.jpg";